import axios from 'axios';
import { logoutAction } from '../actions/authActions';

const baseURL = process.env.REACT_APP_BASE_URL;
const axiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 5000,
    headers: {
        "Content-Type": "application/json",
    },
})

// Request interceptor - ensures every request uses the current token from localStorage
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;

        // Check if error.response exists (might be undefined for network errors, CORS issues, etc.)
        if (!error.response) {
            // Network error or no response from server
            return Promise.reject(error);
        }

        // Prevent infinite loops early
        if (error.response.status === 401 && originalRequest.url === '/users/token/refresh/') {
            logoutAction()
            return Promise.reject(error);
        }

        if (error.response.data && error.response.data.code === "token_not_valid" &&
            error.response.status === 401)
            {
                const refreshToken = localStorage.getItem('refresh_token');
                if (refreshToken) {
                    return axiosInstance
                    .post('/users/token/refresh/', {refresh: refreshToken})
                    .then((response) => {

                        localStorage.setItem('access_token', response.data.access);
                        localStorage.setItem('refresh_token', response.data.refresh);

                        axiosInstance.defaults.headers['Authorization'] = "Bearer " + response.data.access;
                        originalRequest.headers['Authorization'] = "Bearer " + response.data.access;

                        return axiosInstance(originalRequest);
                    })
                    .catch(err => {
                        logoutAction()
                    });
                }
        }
      // specific error handling done elsewhere
      return Promise.reject(error);
  }
);


export default axiosInstance;
